import("../../../assets/js/splide.js")
	.then(({ Splide }) => {
		// Variables
		const sliders = document.querySelectorAll(".content-gallery-carousel .splide")

		// Initializing Splider
		for (let i = 0; i < sliders.length; i++) {
			new Splide(sliders[i], {
				type: "slide",
                arrows: true,
				pagination: true,
				padding: "2rem",
				gap: "1.5rem",
				breakpoints: {
					1023: {
						padding: "1.5rem",
						gap: "1rem",
					}
				}
			}).mount()
		}
	})
	.catch((err) => {
		console.error(err)
	});